import template from './codingactivity.html';
import controller from './codingactivity.controller';
import './codingactivity.styl';

let codingactivityComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default codingactivityComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/codingactivity/codingactivity.component.js